<template>
  <div class="aiService">
    <el-tabs v-model="activeName">
      <el-tab-pane label="防暴力破解配置" name="first">
        <div class="authTip">
          <i class="icon icon-authTip"></i>
          <div>
            <p>{{ tip }}</p>
            <p>{{ tip2 }}</p>
          </div>
        </div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="170px"
        >
          <el-form-item label="防暴力破解" prop="host">
            <el-switch v-model="ruleForm.bruteForceProtected" @change="changeStatus"></el-switch>
          </el-form-item>
          <div v-if="ruleForm.bruteForceProtected">
            <el-form-item label="登录失败次数" prop="failureFactor">
              <el-input-number v-model="ruleForm.failureFactor" :min="1" label="请输入"></el-input-number>
              <p class="label-tips">触发锁定账户的登录失败次数</p>
            </el-form-item>
            <el-form-item label="锁定基础时长" prop="waitIncrement">
              <div class="box">
                <el-input type="number" placeholder="请输入内容" v-model="ruleForm.waitIncrement" :min="0"></el-input>
                <el-select v-model="ruleForm.waitIncrementUnit" placeholder="请选择">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <p class="label-tips">当达到锁定阈值时，应将用户锁定的基础时长。多次锁定时，将以此时长为基准，逐步递增</p>
            </el-form-item>
            <el-form-item label="锁定最大时长" prop="maxFailureWait">
              <div class="box">
                <el-input type="number" placeholder="请输入内容" v-model="ruleForm.maxFailureWait" :min="0"></el-input>
                <el-select v-model="ruleForm.maxFailureWaitUnit" placeholder="请选择">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <p class="label-tips">用户将被锁定的最长时间。如果计算出的锁定时长大于该配置，用户锁定时长则以该配置为准</p>
            </el-form-item>
            <el-form-item label="登录失败计数周期" prop="maxDeltaTime">
              <div class="box">
                <el-input type="number" placeholder="请输入内容" v-model="ruleForm.maxDeltaTime" :min="0"></el-input>
                <el-select v-model="ruleForm.maxDeltaTimeUnit" placeholder="请选择">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <p class="label-tips">登录失败次数重置时间，即经过该配置时长后，账户的登录失败次数将被重置为0</p>
            </el-form-item>
            <el-form-item label="快速登录检测（毫秒）" prop="quickLoginCheckMilliSeconds">
              <el-input-number v-model="ruleForm.quickLoginCheckMilliSeconds" :min="0" label="请输入"></el-input-number>
              <p class="label-tips">两次登录请求之间的时间间隔（单位毫秒）小于该值时，则认定为快速登录</p>
            </el-form-item>
            <el-form-item label="快速登录锁定时长" prop="minimumQuickLoginWait">
              <div class="box">
                <el-input type="number" placeholder="请输入内容" v-model="ruleForm.minimumQuickLoginWait" :min="0"></el-input>
                <el-select v-model="ruleForm.minimumQuickLoginWaitUnit" placeholder="请选择">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <p class="label-tips">快速登录失败后，锁定用户的时长</p>
            </el-form-item>
            <el-form-item>
              <div class="footer">
                <el-button type="primary" @click="putBruteForceDetection">保 存</el-button>
                <!-- <el-button @click="handleCancel">恢 复</el-button> -->
              </div>
            </el-form-item>
          </div>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="会话限制配置" name="second">
        <div class="authTip">
          <i class="icon icon-authTip"></i>
          <div>
            <p>{{ tip3 }}</p>
          </div>
        </div>
        <el-form
          :model="ruleForm1"
          ref="ruleForm1"
          :rules="rules1"
          label-width="280px" >
          <el-form-item label="会话限制" label-width="110px">
            <el-switch v-model="ruleForm1.slot" @change="changeStatus1"></el-switch>
          </el-form-item>
          <div v-if="ruleForm1.slot">
            <el-form-item label="每个用户在当前租户下的最大并发会话数" prop="userRealmLimit">
              <el-input type="number" placeholder="请输入内容" v-model="ruleForm1.userRealmLimit" :min="0"></el-input>
              <p class="label-tips">填写0时禁用此限制，即没有会话数限制</p>
            </el-form-item>
            <el-form-item label="每个用户在每个应用下的最大并发会话数" prop="userClientLimit">
              <el-input type="number" placeholder="请输入内容" v-model="ruleForm1.userClientLimit" :min="0"></el-input>
              <p class="label-tips">填写0时禁用此限制。如果启用了上一项限制，则该项配置值应小于上一项的配置值</p>
            </el-form-item>
            <el-form-item label="用户会话超过限制时的处理规则" prop="behaviorIndex">
              <el-select v-model="ruleForm1.behaviorIndex" placeholder="请选择">
                <el-option
                  v-for="item in options1"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <div class="footer">
                <el-button type="primary" @click="putBruteForceDetection(2)">保 存</el-button>
              </div>
            </el-form-item>
          </div>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import APIS from "@/apis/securitySetting.js"

export default {
  data() {
    // 检验wxip
    var checkNumber = (rule, value, callback) => {
      // 至少8位，需包含大小写字母和数字
      if (value < 0 || String(value).indexOf('.') > -1 ) {
        callback(new Error(`只能输入正整数和0`))
      } else {
        callback()
      }
    }
    var checkNumber1 = (rule, value, callback) => {
      // 至少8位，需包含大小写字母和数字
      if (String(value).indexOf('.') > -1) {
        callback(new Error(`只能输入正整数`))
      } else {
        callback()
      }
    }
    return {
      ruleForm: {
        bruteForceProtected: false,
        maxFailureWait: 15,//最小值为1
        minimumQuickLoginWait: 1,
        waitIncrement: 1,
        quickLoginCheckMilliSeconds: 1000,
        maxDeltaTime: 12,
        failureFactor: 30,
        waitIncrementUnit: "Minutes",//参数Seconds，Minutes，Hours，Days
        minimumQuickLoginWaitUnit: "Minutes",//参数Seconds，Minutes，Hours，Days
        maxFailureWaitUnit: "Minutes",//参数Seconds，Minutes，Hours，Days
        maxDeltaTimeUnit: "Hours"//参数Seconds，Minutes，Hours，Days
      },
      ruleForm1: {
        slot: false,
        userRealmLimit:3,
        userClientLimit:0,
        behaviorIndex: 0,
        behavior: 'Deny new session',
        firstCreate:true
      },
      rules: {
        maxFailureWait: [
          { required: true, message: "请输入锁定最大时长", trigger: "blur" },
          { required: true, validator: checkNumber, trigger: ["blur", 'change'] }
        ],
        minimumQuickLoginWait: [
          { required: true, message: "请输入快速登录锁定时长", trigger: "blur" },
          { required: true, validator: checkNumber, trigger: ["blur", 'change'] }
        ],
        waitIncrement: [
          { required: true, message: "请输入锁定基础时长", trigger: "blur" },
          { required: true, validator: checkNumber, trigger: ["blur", 'change'] }
        ],
        failureFactor: [
          { required: true, message: "请输入登录失败次数", trigger: "blur" },
          { required: true, validator: checkNumber1, trigger: ["blur", 'change'] }
        ],
        quickLoginCheckMilliSeconds: [
          { required: true, message: "请输入快速登录检测", trigger: "blur" },
          { required: true, validator: checkNumber, trigger: ["blur", 'change'] }
        ],
        maxDeltaTime: [
          { required: true, message: "请输入登录失败计数周期", trigger: "blur" },
          { required: true, validator: checkNumber, trigger: ["blur", 'change'] }
        ]
      },
      rules1: {
        userRealmLimit: [
          { required: true, message: "请输入每个用户在当前租户下的最大并发会话数", trigger: "blur" },
          { required: true, validator: checkNumber, trigger: ["blur", 'change'] }
        ],
        userClientLimit: [
          { required: true, message: "请输入每个用户在每个应用下的最大并发会话数", trigger: "blur" },
          { required: true, validator: checkNumber, trigger: ["blur", 'change'] }
        ],
        behaviorIndex: [
          { required: true, message: "请选择用户会话超过限制时的处理规则", trigger: "blur" },
          { required: true, validator: checkNumber, trigger: ["blur", 'change'] }
        ],
      },
      options: [{
          value: 'Minutes',
          label: '分'
        }, {
          value: 'Hours',
          label: '时'
        }, {
          value: 'Days',
          label: '天'
        }],
        options1: [{
          value: 0,
          label: '拒绝新会话'
        }, {
          value: 1,
          label: '结束最早的会话'
        }],
      tip:"暴力破解是指利用穷举的方法对用户名和密码进行匹配，直到匹配到正确的内容。当用户设置的密码较为单一时，则通过工具会很快的获取到正确的用户名和密码进行登录。",
      tip2:'IDaaS支持防暴力破解功能，通过对同一账户的请求时间及错误请求次数来限制暴力破解，当超过设置的条件时则对提交认证请求的I账户进行锁定。',
      tip3:'IDaaS支持配置用户可拥有的会话数限制。',
      breadcrumb: [
        {
          label: "安全设置"
        }
      ],
      activeName: 'first',
    }
  },
  mounted() {
    this.getBruteForceDetection()
    this.getBruteForceDetection(2)
  },
  methods: {
    // 获取应用列表
    async getBruteForceDetection(type) {
      let apiName = type > 1 ? 'getsessionLimit' : 'getBruteForceDetection'
      let { status, data } = await APIS[apiName](this.$realm)
      if (status === 0) {
        if(type > 1) {
          this.ruleForm1.slot = data.slot ? true : false
          this.ruleForm1.userRealmLimit = data.userRealmLimit || data.userRealmLimit === 0 ? data.userRealmLimit : 3
          this.ruleForm1.userClientLimit = data.userClientLimit || data.userClientLimit === 0 ? data.userClientLimit : 0
          this.ruleForm1.behavior = data.behavior ? data.behavior : "Deny new session"
          this.ruleForm1.firstCreate = data.firstCreate ? true : false
          this.ruleForm1.behaviorIndex = this.ruleForm1.behavior === 'Terminate oldest session' ? 1 : 0
        } else {
          this.ruleForm = data
        }
      }
    },
    async putBruteForceDetection(type) {
      let str = 'ruleForm', apiName = 'putBruteForceDetection', params = this.ruleForm;
      if (type > 1) {
        str = 'ruleForm1'
        apiName = 'putsessionLimit'
        this.ruleForm1.userClientLimit = Number(this.ruleForm1.userClientLimit)
        this.ruleForm1.userRealmLimit = Number(this.ruleForm1.userRealmLimit)
        this.ruleForm1.behavior = this.ruleForm1.behaviorIndex === 1 ? 'Terminate oldest session' : "Deny new session"
        params = JSON.parse(JSON.stringify(this.ruleForm1))
        delete params.behaviorIndex
      }
      let validate = false
      this.$refs[str].validate((valid) => {
        if (valid) {
          validate = true
        }
      })
      if (!validate) {
        return false
      }
      let { status } = await APIS[apiName](this.$realm, {
          data: params
        })
      if (status === 0) {
        this.getBruteForceDetection(type)
      }
    },
    changeStatus() {
      this.putBruteForceDetection()
    },
    changeStatus1(e) {
      if(!e) {
        this.putBruteForceDetection(2)
      }
    },
    handleCancel() {
      this.$refs["ruleForm"].resetFields()
    }
  }
}
</script>

<style lang="scss">
  .box {
    display: flex;
    .el-select {
      width: 120px;
    }
  }
  .el-form-item__error {
    white-space: nowrap;
  }
</style>
